import { createFileRoute } from '@tanstack/react-router';
import { ViewSubmissionScreen } from '@/quiz-submission/ViewSubmissionScreen';

/**
 * The group mount of the view screen. Legacy's member template is a ONE-LINE
 * `require` of this group template
 * (`themes/wbs/buddypress/members/single/course-study/quiz_view.php:1`), so the
 * screen is built once in `@/quiz-submission/` and mounted twice — see
 * `ViewSubmissionScreen` for the shared behaviour (R30, R31, X8).
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/view/$submissionId',
)({
  component: GroupQuizSubmissionViewScreen,
});

function GroupQuizSubmissionViewScreen() {
  const { submissionId } = Route.useParams();
  return (
    <ViewSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
